import Switchddress from 'switch-address'

const switchAddress = new Switchddress({
  address: { // 加入环境--地址映射
    测试: '/ceshi',
    cs_10205: '/cs_10205',
    线上: '/api',
    production: '',
  },
  default: process.env.NODE_ENV, // 指定当前web所在的部署环境
  exclude: 'production', // 指定switch-address模块无需出现的环境
  color: '#f66034' // 指定图标的颜色
})
console.log(switchAddress.address)
var api = {
  BASEURL: switchAddress.address,//解决本地跨域
  Login: '/api/login',// 登录
  loginOut: '/api/loginOut',// 登出
  orderHistoryExport: '/api/orderHistoryExport',
  fileUpload: '/api/fileUpload',
  newOrderUpdate: '/api/orderUpdate',
  orderIndexExport: '/api/orderIndexExport',

  resetPassword: '/api/user/resetPassword',//修改密码
  users: '/api/user/users',//用户列表
  addUser: '/api/user/addUser',
  editUser: '/api/user/editUser',
  delUser: '/api/user/delUser',

  rolesList: '/api/permission/rolesList',
  addRole: '/api/permission/addRole',
  delRole: '/api/permission/delRole',
  editRole: '/api/permission/editRole',
  rolePermissions: '/api/permission/rolePermissions',
  getPermission: '/api/permission/getPermission',
  addPermission: '/api/permission/addPermission',
  editPermission: '/api/permission/editPermission',
  delPermission: '/api/permission/delPermission',
  changePermissionStatus: '/api/permission/changePermissionStatus',
  routeList: '/api/permission/routeList',

  rebateList: '/api/config/rebateList',
  rebateAdd: '/api/config/rebateAdd',
  rebateEdit: '/api/config/rebateEdit',
  rebateDel: '/api/config/rebateDel',
  mediaList: '/api/config/mediaList',
  mediaAdd: '/api/config/mediaAdd',
  mediaEdit: '/api/config/mediaEdit',
  mediaDel: '/api/config/mediaDel',
  platformList: '/api/config/platformList',
  platformAdd: '/api/config/platformAdd',
  platformEdit: '/api/config/platformEdit',
  platformDel: '/api/config/platformDel',
  accountList: '/api/config/accountList',
  accountAdd: '/api/config/accountAdd',
  accountEdit: '/api/config/accountEdit',
  accountDel: '/api/config/accountDel',
  accountSelect: '/api/config/accountSelect',
  companyAdd: '/api/config/companyAdd',
  companyEdit: '/api/config/companyEdit',
  companyList: '/api/config/companyList',
  companyDel: '/api/config/companyDel',
  uploadAccount: '/api/config/uploadAccount',
  mediaListSelect: '/api/config/mediaListSelect',
  customerList: '/api/config/customerList',
  customerAdd: '/api/config/customerAdd',
  customerDel: '/api/config/customerDel',
  mcnList: '/api/config/mcnList',
  mcnAdd: '/api/config/mcnAdd',
  mcnDel: '/api/config/mcnDel',
  taxRate: '/api/config/taxRate',
  setTaxRate: '/api/config/setTaxRate',
  delTaxRate: '/api/config/delTaxRate',
  signCompanyList: '/api/config/signCompanyList',
  setSignCompany: '/api/config/setSignCompany',
  delSignCompany: '/api/config/delSignCompany',
  costCompanys: '/api/config/costCompanys',
  partyBAccountList: '/api/config/partyBAccountList',
  partyBAccountStore: '/api/config/partyBAccountStore',
  partyBAccountUpdate: '/api/config/partyBAccountUpdate',
  partyBAccountDestroy: '/api/config/partyBAccountDestroy',
  costRebateConfirmApplyList: '/api/config/costRebateConfirmApplyList',
  costRebateConfirmApply: '/api/config/costRebateConfirmApply',
  getCostRebateConfirmConditions: '/api/config/getCostRebateConfirmConditions',
  customerEdit: '/api/config/customerEdit',
  mcnEdit: '/api/config/mcnEdit',
  customerInvoiceInformationUpdateRecordsList: '/api/config/customerInvoiceInformationUpdateRecordsList',

  projectIndex: '/api/project/index',
  projectAdd: '/api/project/add',
  projectUpdate: '/api/project/update',
  projectDetail: '/api/project/detail',
  projectDel: '/api/project/batchDel',
  projectEditInfo: '/api/project/getEditInfo',

  projectOrder: '/api/order/projectOrder',
  orderAdd: '/api/order/add',
  orderUpdate: '/api/order/update',
  orderDel: '/api/order/batchDel',
  orderGetEditInfo: '/api/order/getEditInfo',
  orderLock: '/api/order/lockOrder',
  columnSearch: '/api/order/columnSearch',
  orderTotalList: '/api/order/index',
  orderMonthList: '/api/order/orderMonthList',
  lockMonthOrder: '/api/order/lockMonthOrder',
  orderMonthVerifys: '/api/order/orderMonthVerifys',
  getOrderEditing: '/api/order/getOrderEditing',
  verifyOrderEdit: '/api/order/verifyOrderEdit',
  delVerifyOrder: '/api/order/delVerifyOrderSecond',
  getOrderVeifyRecords: '/api/order/getOrderVeifyRecords',
  orderImport: '/api/order/orderImport',
  invoiceList: '/api/order/invoiceList',
  invoiceDetail: '/api/order/invoiceDetail',
  setInvoice: '/api/order/setInvoice',
  verifyInvoice: '/api/order/verifyInvoice',
  editInvoice: '/api/order/editInvoice',
  batchUpdate: '/api/order/batchUpdate',
  getOrderEditingDetail: '/api/order/getOrderEditingDetail',
  orderEditingExport: '/api/order/orderEditingExport',
  orderEditingExportNew: '/api/order/orderEditingExportNew',
  invoiceOrderExport: '/api/order/invoiceOrderExport',
  orderImportSecond: '/api/order/orderImportSecond',
  orderIncomeList: '/api/order/orderIncomeList',
  orderMcnList: '/api/order/orderMcnList',
  negativeIndex: '/api/order/negativeIndex',
  batchSetNotes: '/api/order/batchSetNotes',
  incompleteList: '/api/order/incompleteList',
  orderIcomeUpdate: '/api/order/orderIcomeUpdate',
  orderIncomeBatchDel: '/api/order/orderIncomeBatchDel',
  orderMcnBatchDel: '/api/order/orderMcnBatchDel',
  orderMcnUpdate: '/api/order/orderMcnUpdate',
  lockMonthOrderSecond: '/api/order/lockMonthOrderSecond',
  allColumnSearch: '/api/order/allColumnSearch',
  actualInvoiced: '/api/order/actualInvoiced',
  delActualInvoiced: '/api/order/delActualInvoiced',
  batchVerifyDetail: '/api/order/batchVerifyDetail',
  batchVerify: '/api/order/batchVerify',
  allColumnSearchSecond: '/api/order/allColumnSearchSecond',
  getAllMontList: '/api/order/getAllMontList',
  unlockOrder: '/api/order/unlockOrder',
  order_enableBatchUpdateField: '/api/order/enableBatchUpdateField',
  order_verifyZeroOrder: '/api/order/verifyZeroOrder',
  order_deleteZeroOrder: '/api/order/deleteZeroOrder',
  order_zeroOrderList: '/api/order/zeroOrderList',
  order_importUpdate: '/api/order/importUpdate',
  order_reminder: '/api/order/reminder',
  orderMcnStat: '/api/order/orderMcnStat',
  orderIndexStat: '/api/order/orderIndexStat',

  documentAdd: '/api/document/documentAdd',
  documentMove: '/api/document/documentMove',
  documentList: '/api/document/documentList',
  documentDel: '/api/document/documentDel',
  documentDetail: '/api/document/documentDetail',

  preData: '/api/statements/preData',
  statementsAdd: '/api/statements/add',
  statementsIndex: '/api/statements/index',
  statementsDetail: '/api/statements/detail',
  statementsExport: '/api/statements/export',
  statementsUpdate: '/api/statements/update',
  statementsVerify: '/api/statements/verify',
  statementsDelVerify: '/api/statements/delVerify',
  pddStatus: '/api/statements/pddStatus',
  statements_reApply: '/api/statements/reApply',

  profitTrend: '/api/stastistics/profitTrend',
  orderMonthReport: '/api/stastistics/orderMonthReport',
  salerPerformance: '/api/stastistics/salerPerformance',
  stastistics_changeMonthTotal: '/api/stastistics/changeMonthTotal',

  orderImportCost: '/api/cost/orderImport',
  costIndex: '/api/cost/costIndex',
  orderIndex: '/api/orderIndex',
  costUpdate: '/api/cost/costUpdate',
  offlineIndex: '/api/cost/offlineIndex',
  costDel: '/api/cost/costDel',
  offlineUpdate: '/api/cost/offlineUpdate',
  offlineDel: '/api/cost/offlineDel',
  batchSetRedInvoice: '/api/cost/batchSetRedInvoice',
  setCostInvoice: '/api/cost/setCostInvoice',
  costInvoiceApplyList: '/api/cost/costInvoiceApplyList',
  costApplyVerify: '/api/cost/costApplyVerify',
  costApplyVoid: '/api/cost/costApplyVoid',
  delCostApply: '/api/cost/delCostApply',
  getOrderListByCondition: '/api/cost/getOrderListByCondition',
  costApplyDownload: '/api/cost/costApplyDownload',
  costInvoiceExport: '/api/cost/costInvoiceExport',
  getInvoiceTotalAmount: '/api/cost/getInvoiceTotalAmount',
  getMediaList: '/api/cost/getMediaList',
  setofflineCostInvoice: '/api/cost/setofflineCostInvoice',
  offlineCostInvoiceApplyList: '/api/cost/offlineCostInvoiceApplyList',
  delOfflineCostApply: '/api/cost/delOfflineCostApply',
  offlineCostApplyVerify: '/api/cost/offlineCostApplyVerify',
  offlineCostApplyDownload: '/api/cost/offlineCostApplyDownload',
  costApplyBatchVerify: '/api/cost/costApplyBatchVerify',

  invoiceCancel: '/api/customerInvoices/invoiceCancel',
  invoiceWithdraw: '/api/customerInvoices/invoiceWithdraw',
  editInvoiceNew: '/api/customerInvoices/editInvoiceNew',
  //作废发票
  voidedOrderAdd: '/api/customerInvoices/voidedOrderAdd',
  verifyVoidedInvoice: '/api/customerInvoices/verifyVoidedInvoice',
  voidedOrderUpdate: '/api/customerInvoices/voidedOrderUpdate',
  redInvoicesList: '/api/customerInvoices/redInvoicesList',
  redInvoicesDetail: '/api/customerInvoices/redInvoicesDetail',
  redInvoicesVerify: '/api/customerInvoices/redInvoicesVerify',
  redInvoicesEdit: '/api/customerInvoices/redInvoicesEdit',
  redApplyImport: '/api/customerInvoices/redApplyImport',
  redApplyOrders: '/api/customerInvoices/redApplyOrders',
  redApplyConfirm: '/api/customerInvoices/redApplyConfirm',

  // 4月之前
  statementsComplement_index: '/api/statementsComplement/index',
  statementsComplement_add: '/api/statementsComplement/add',
  statementsComplement_detail: '/api/statementsComplement/detail',
  statementsComplement_update: '/api/statementsComplement/update',
  statementsComplement_verify: '/api/statementsComplement/verify',
  statementsComplement_delVerify: '/api/statementsComplement/delVerify',

  customerInvoicesComplement_add: '/api/customerInvoicesComplement/add',
  customerInvoicesComplement_index: '/api/customerInvoicesComplement/index',
  customerInvoicesComplement_detail: '/api/customerInvoicesComplement/detail',
  customerInvoicesComplement_update: '/api/customerInvoicesComplement/update',
  customerInvoicesComplement_verify: '/api/customerInvoicesComplement/verify',
  customerInvoicesComplement_actualInvoiced: '/api/customerInvoicesComplement/actualInvoiced',
  customerInvoicesComplement_delActualInvoiced: '/api/customerInvoicesComplement/delActualInvoiced',

  past_orderImport: '/api/past/orderImport',
  past_add: '/api/past/add',
  past_index: '/api/past/index',
  past_update: '/api/past/update',
  past_batchDel: '/api/past/batchDel',
  past_submitVerify: '/api/past/submitVerify',
  past_orderVerify: '/api/past/orderVerify',
  past_batchOrderVerify: '/api/past/batchOrderVerify',

  backup_index: '/api/backup/index',
  backup_export: '/api/backup/export',

  extraUpdate: '/api/orderCost/extraUpdate',
  collectionDataSave: '/api/orderCost/orderCollectionDataSave',
  costRebateApplys: '/api/orderCost/costRebateApplys',
  costRebateApplyDetails: '/api/orderCost/costRebateApplyDetails',
  costRebateVerify: '/api/orderCost/costRebateVerify',

  deleteStatements: '/api/tool/deleteStatements',

  export_index: '/api/export/index',

  salerOrderImportValidate: '/api/orderIncome/salerOrderImportValidate',
  salerOrderImportConfirm: '/api/orderIncome/salerOrderImportConfirm',

  mjExecImportValidate: '/api/order/mjExecImportValidate',
  mjExecImportConfirm: '/api/order/mjExecImportConfirm',
  // 获取执行媒介列表
  getExecMediumList: '/api/order/getExecMediumList',

  orderExtra_recordList: '/api/orderExtra/recordList',
  orderExtra_batchDel: '/api/orderExtra/batchDel',

  preAuditRecordSave: '/api/preAudit/preAuditRecordSave',
  getPreAuditRecord: '/api/preAudit/getPreAuditRecord',

  statementsSeal_apply: '/api/statementsSeal/apply',
  statementsSeal_applyList: '/api/statementsSeal/applyList',
  statementsSeal_details: '/api/statementsSeal/details',
  statementsSeal_verifyList: '/api/statementsSeal/verifyList',
  statementsSeal_verify: '/api/statementsSeal/verify',
  statementsSeal_sealList: '/api/statementsSeal/sealList',
  statementsSeal_sealAction: '/api/statementsSeal/sealAction',
  statementsSeal_remind: '/api/statementsSeal/remind',
  statementsSeal_del: '/api/statementsSeal/del',

  statementsSeal_fileList: '/api/statementsFile/fileList',
  statementsSeal_fileAction: '/api/statementsFile/fileAction',
  statementsSeal_detailList: '/api/statementsFile/detailList',
  statementsSeal_detailExport: '/api/statementsFile/detailExport',

  monthEditList: '/api/order/getMonthEditInfo',
}

export {
  api
}



// WEBPACK FOOTER //
// ./src/assets/config/interface_api.js